import { render, staticRenderFns } from "./FooterLinkModular.vue?vue&type=template&id=2d7ed082&scoped=true&"
import script from "./FooterLinkModular.vue?vue&type=script&lang=js&"
export * from "./FooterLinkModular.vue?vue&type=script&lang=js&"
import style0 from "./FooterLinkModular.vue?vue&type=style&index=0&id=2d7ed082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ed082",
  null
  
)

export default component.exports